// extracted by mini-css-extract-plugin
module.exports = {"info":"Info-module--info--3d09L","url":"Info-module--url--AaA20","removeButton":"Info-module--removeButton--3iO3F"};